import React from "react";
import { Grid, Box } from "@mui/material";
import "./mapData.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/processor/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import MapDataTable from "../../../components/MapDataTable/TemplateDriven/MapDataTable";
import CNCTableWrapper from "../../../components/MapDataTable/Free-Form/CNCTableWrapper";
import ImageViewer from "./ImageViewer";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import QCTable from "../../../components/MapDataTable/QCTable/QCTable";

class DataEntryConatainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      selectedFile: {
        tagName: "",
        fileNo: 0, // index is considered as file
        pageNo: 0,
      },
      // showParameterTable: false,
      // batch_extraction_type : "free_form"
      // batch_extraction_type: localStorage.getItem("batch_extraction_type"),
      batch_for_qc: localStorage.getItem("batch_for_qc"),
    };
  }

  handleCloseModal = () => {
    this.setState({
      openRejectionModal: false,
    });
  };

  handleReject = (remark) => {
    this.props?.child.current.mapData("reject", remark);
    this.setState({
      openRejectionModal: false,
    });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ showParameterTable: newValue === 1 }); // Set true for Parameter Table (Tab 1), false for QC Table (Tab 0)
  };

  render() {
    return (
      <div>
        {this.props?.coorData && this.props?.coorData?.length ? (
          <Box className="data-entry-container">
            <Grid container spacing={1}>
              {this?.props?.hideScreen ? (
                <Grid xs={this?.props?.leftgrid} item>
                  <ImageViewer
                    // disabled={
                    //   this?.state?.batch_for_qc === "true" ? true : false
                    // }
                    // isFullView={this?.props?.isFullView}
                    isTemplateDriven={
                      this.props?.is_template_uploaded ? true : false
                    }
                    role="validator"
                    {...this.props}
                  />
                </Grid>
              ) : (
                <></>
              )}
              <Grid xs={this?.props?.rightgrid} item>
                <Box className="container-1">
                  {/* <Tabs
                  size="small"
                  value={this.state.showParameterTable ? 1 : 0} // 0 for QC Table, 1 for Parameter Table
                  onChange={this.handleTabChange}
                  // centered
                  TabIndicatorProps={{
                    style: {
                      marginBottom: "2px", // Adds some space between the indicator and the tab text
                    },
                  }}
                  sx={{
                    minHeight: "35px", // Set minimum height for the Tabs component
                    height: "38px", // Set fixed height for the Tabs component
                    paddingTop: "5px",
                    paddingLeft: "20px",
                  }}
                >
                  <Tab
                    label="QC Table"
                    sx={{
                      backgroundColor: !this.state.showParameterTable
                        ? "#1976d2"
                        : "",
                      color: !this.state.showParameterTable
                        ? "#ffff !important"
                        : "",
                      transition: "background-color 0.3s",
                      minHeight: "20px",
                      padding: "5px 10px",
                      fontSize: "0.875rem",
                      borderRadius: "6px",
                      marginRight: 1,
                    }}
                  />

                  <Tab
                    label="Extraction"
                    className="mapping_toggle_tab"
                    sx={{
                      backgroundColor: this.state.showParameterTable
                        ? "#1976d2"
                        : "",
                      color: this.state.showParameterTable
                        ? "#ffff !important"
                        : "",
                      transition: "background-color 0.3s",
                      minHeight: "20px", // Decrease the height of the tab
                      padding: "5px 10px", // Padding to make it look smaller
                      fontSize: "0.875rem", // Smaller font size
                      borderRadius: "6px",
                    }}
                  />
                </Tabs>

                <Divider /> */}

                  {/* {this?.state?.batch_extraction_type === "template_driven" ? ( */}
                  {this?.state?.batch_for_qc === "false" ? (
                    this.props?.is_template_uploaded === true ? (
                      //component for table
                      <MapDataTable
                        selectedFile={this.state?.selectedFile}
                        parametersData={this.props?.parametersData}
                        ref={this.props?.child}
                        role={localStorage?.userRole}
                        reProcess={this.props.reProcess}
                        isDataRejectedByValidator={
                          this?.props?.isDataRejectedByValidator
                        }
                        // isFullView={this?.props?.isFullView}
                        reProcessEntireBatch={this?.props?.reProcessEntireBatch}
                        entireBatchRejectedByVali={
                          this?.props?.entireBatchRejectedByVali
                        }
                        showContextMenu={true}
                        showParameterTable={true}
                      />
                    ) : this.props?.is_template_uploaded === false ? (
                      <CNCTableWrapper
                        selectedFile={this.state?.selectedFile}
                        ref={this.props?.child}
                        role={localStorage.userRole}
                        parametersData={this.props?.parametersData}
                        columnsCount={this.props?.columnsCount}
                        reProcess={this.props?.reProcess}
                        isDataRejectedByValidator={
                          this?.props?.isDataRejectedByValidator
                        }
                        showContextMenu={true}
                        isDisableOnChangeInput={false}
                        isDisableOnBlur={false}
                        // isFullView={this?.props?.isFullView}
                        reProcessEntireBatch={this?.props?.reProcessEntireBatch}
                        entireBatchRejectedByVali={
                          this?.props?.entireBatchRejectedByVali
                        }
                        showParameterTable={true}
                      />
                    ) : (
                      <TableSkeleton />
                    )
                  ) : (
                    <QCTable
                      role="processor"
                      selectedFile={this.state?.selectedFile}
                      qcTemplateData={this?.props?.qcTemplateData || []}
                      ref={this.props?.qcChild}
                      showParameterTable={false}
                      assignToValidator={this.props?.assignToValidator}
                      // isFullView={this?.props?.isFullView}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={this?.props?.leftgrid}>
              <TableSkeleton />
            </Grid>
            <Grid item xs={this?.props?.rightgrid}>
              <TableSkeleton />
            </Grid>
          </Grid>
        )}

        {this.state.openRejectionModal && (
          <ModalProcessor
            modalOpen={this.state.openRejectionModal}
            handleClose={this.handleCloseModal}
            handleReject={this.handleReject}
            isShowClearButton={false}
            disableDeleteRejection={true}
            isShowDeleteButton={false}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  //fetch states from redux store
  return {
    coorData: state.pro?.coorData?.coordinatesDetails || [],
    parametersData: state.pro?.coorData?.mapping_details?.parametersData || [],
    is_template_uploaded: state.pro?.coorData?.is_template_uploaded,
    apiStatus: state.pro?.apiStatus,
    columnsCount: state.pro?.coorData?.mapping_details?.columnsCount,
    reProcess: state.pro?.coorData?.mapping_details?.reProcess,
    isDataRejectedByValidator:
      state.pro?.coorData?.mapping_details?.isDataRejectedByValidator,
    validatorRowRejectionData:
      state.pro?.coorData?.mapping_details?.validatorRowRejectionData,
    proRowRejectionData:
      state.pro?.coorData?.mapping_details?.proRowRejectionData,
    reProcessEntireBatch:
      state.pro?.coorData?.mapping_details?.reProcessEntireBatch,
    entireBatchRejectedByVali:
      state?.pro?.coorData?.mapping_details?.entireBatchRejectedByVali,
    qcTemplateData: state.pro?.coorData?.mapping_details?.parametersData || [],
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataEntryConatainer);
